/** Mensagens legíveis para falhas de jobs IA no modal de onboarding. */
export function humanizeJobError(message) {
  const raw = String(message || '').trim();
  if (!raw) return 'Não foi possível gerar treinos. Tente novamente.';

  const lower = raw.toLowerCase();

  if (lower.includes("reading 'filename'") || lower.includes('reading "filename"')) {
    return 'Falha interna no servidor ao gerar treinos. Atualize a página e tente de novo.';
  }

  if (lower.includes('tempo esgotado') || lower.includes('timeout')) {
    return 'A geração demorou demais. Tente novamente.';
  }

  if (lower.includes('rate limit') || lower.includes('429')) {
    return 'Limite de pedidos à IA atingido. Aguarde cerca de 1 minuto.';
  }

  return raw;
}
